// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3a1sF","itemA":"Write_itemA__3MPf9","itemB":"Write_itemB__2oV8W","itemC":"Write_itemC__3cUmK","itemD":"Write_itemD__38f9t"};